module.exports = __webpack_public_path__ + "static/media/my ownership1.686f86b3.svg";